import apiFetch from '../../apiFetch'

export default function (dossierId, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/dossierStock/skipPhotos/${dossierId}`, method: 'PUT', token: token, lastAccessDate })
}
